// extracted by mini-css-extract-plugin
export default {"panBox":"pan_panBox__uKsrY","panTypo":"pan_panTypo__5lOXQ","panTypo1":"pan_panTypo1__9vyFt"};